// tableFloatingMenuConfigs.js
// Button/action configurations for the table floating menu.
// Two sets are exported:
//   CELL_CURSOR_CONFIGS   — shown when the cursor is inside a cell (TextSelection, isInTable)
//   CELL_RANGE_CONFIGS    — shown when one or more cells are selected (CellSelection)

import BorderTopRounded from "@mui/icons-material/BorderTopRounded";
import BorderBottomRounded from "@mui/icons-material/BorderBottomRounded";
import BorderLeftRounded from "@mui/icons-material/BorderLeftRounded";
import BorderRightRounded from "@mui/icons-material/BorderRightRounded";
import DeleteRounded from "@mui/icons-material/DeleteRounded";
import MergeTypeRounded from "@mui/icons-material/MergeTypeRounded";
import CallSplitRounded from "@mui/icons-material/CallSplitRounded";
import TableRowsRounded from "@mui/icons-material/TableRowsRounded";

/**
 * Actions available when the text cursor is simply inside a table cell
 * (no multi-cell selection).
 */
export const CELL_CURSOR_CONFIGS = [
    {
        type: "addRowBefore",
        label: "Row above",
        title: "Add row above current cell",
        icon: BorderTopRounded,
        group: "row",
    },
    {
        type: "addRowAfter",
        label: "Row below",
        title: "Add row below current cell",
        icon: BorderBottomRounded,
        group: "row",
    },
    {
        type: "addColumnBefore",
        label: "Col left",
        title: "Add column to the left",
        icon: BorderLeftRounded,
        group: "col",
    },
    {
        type: "addColumnAfter",
        label: "Col right",
        title: "Add column to the right",
        icon: BorderRightRounded,
        group: "col",
    },
    {
        type: "deleteRow",
        label: "Del row",
        title: "Delete current row",
        icon: DeleteRounded,
        group: "delete",
    },
    {
        type: "deleteColumn",
        label: "Del col",
        title: "Delete current column",
        icon: DeleteRounded,
        group: "delete",
    },
    {
        type: "deleteTable",
        label: "Del table",
        title: "Delete entire table",
        icon: DeleteRounded,
        group: "delete",
    },
];

/**
 * Actions available when multiple cells are selected (CellSelection).
 * Merge / split are first because they are the primary reason to multi-select.
 */
export const CELL_RANGE_CONFIGS = [
    {
        type: "mergeCells",
        label: "Merge",
        title: "Merge selected cells",
        icon: MergeTypeRounded,
        group: "merge",
    },
    {
        type: "splitCell",
        label: "Split",
        title: "Split merged cell",
        icon: CallSplitRounded,
        group: "merge",
    },
    {
        type: "toggleHeaderCell",
        label: "Header",
        title: "Toggle header style on selected cells",
        icon: TableRowsRounded,
        group: "header",
    },
    {
        type: "addRowBefore",
        label: "Row above",
        title: "Add row above selection",
        icon: BorderTopRounded,
        group: "row",
    },
    {
        type: "addRowAfter",
        label: "Row below",
        title: "Add row below selection",
        icon: BorderBottomRounded,
        group: "row",
    },
    {
        type: "addColumnBefore",
        label: "Col left",
        title: "Add column to the left",
        icon: BorderLeftRounded,
        group: "col",
    },
    {
        type: "addColumnAfter",
        label: "Col right",
        title: "Add column to the right",
        icon: BorderRightRounded,
        group: "col",
    },
    {
        type: "deleteRow",
        label: "Del row",
        title: "Delete selected rows",
        icon: DeleteRounded,
        group: "delete",
    },
    {
        type: "deleteColumn",
        label: "Del col",
        title: "Delete selected columns",
        icon: DeleteRounded,
        group: "delete",
    },
    {
        type: "deleteTable",
        label: "Del table",
        title: "Delete entire table",
        icon: DeleteRounded,
        group: "delete",
    },
];
